













import Vue from 'vue';
import config from '../config';

export default Vue.extend({
  data() {
    return {
      appName: config.appName,
    };
  },
  computed: {
    active(): string | undefined {
      return this.$route.path;
    },
  },
});
